import FunctionPane from './FunctionPane'

export default FunctionPane
